module.exports = "<div>\r\n    <header></header>\r\n    <div class=\"inner-sidenav-content\">\r\n        <div>\r\n            <router-outlet></router-outlet>\r\n        </div>\r\n    </div>\r\n\r\n</div>"


//////////////////
// WEBPACK FOOTER
// C:/dev/Perso/urmeo/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main